import { FC } from 'react';
import BasePageHeader from 'components/PageHeader';
import { useDetailsBooking } from 'lib/hooks';
import { getBookingListPageLink } from 'lib/links';
import * as track from 'lib/gaTracking/bookingDetailsPageEvents';

const PageHeader: FC = () => {
  const { booking } = useDetailsBooking();
  const hasQFFAccount = !!booking.account;

  return (
    <BasePageHeader
      title="Booking details"
      bookingRef={booking.reference}
      showCloseSessionButton={!hasQFFAccount}
      backLinkUrl={hasQFFAccount ? getBookingListPageLink() : undefined}
      backLinkTitle={hasQFFAccount ? 'My hotel bookings' : undefined}
      onClickBackLink={track.yourHotelsReturnLinkSelected}
    />
  );
};

export default PageHeader;
